import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { ReactComponent as RootIcon } from '../../../assets/icons/slot_placeholder.svg';
import { useTranslate } from '../../../hooks/usePageTitle';
import { useIsSSRMode } from '../../../hooks/useIsSSRMode';
import { baseURLSelector } from '../../../redux/reducers/app/params';
import { NAMESPACES } from '../../../constants/namespaces';
import BreadcrumbsItem from './BreadcrumbsItem';
import styles from './BreadcrumbsItemRoot.module.css';

const ROOT_PAGE_TRANSLATION_KEY = 'Root page seo title';

const BreadcrumbsItemRoot = ({ className, ...props }) => {
  const translate = useTranslate(NAMESPACES.INITIAL);
  const title = translate(ROOT_PAGE_TRANSLATION_KEY);
  const baseUrl = useSelector(baseURLSelector);
  const isSSRMode = useIsSSRMode();

  return (
    <BreadcrumbsItem
      to={baseUrl}
      className={classNames(styles.component, className)}
      title={title}
      isExternal={true}
      {...props}
    >
      <RootIcon
        className={styles.icon}
        data-id={isSSRMode ? 'preserve-rendering' : undefined}
      />
      <span className={styles.title}>{title}</span>
    </BreadcrumbsItem>
  );
};

export default BreadcrumbsItemRoot;
